import React, { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { Nav } from "@/components/Nav";
import Garden from "@/pages/Garden";
import Roses from "@/pages/Roses";
import HowItWorks from "@/pages/HowItWorks";
import Profile from "@/pages/Profile";
import Member from "@/pages/Member";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const finish = async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile", { replace: true });
      } catch (err) {
        console.error("Google sign-in session exchange failed", err);
        setUser(false);
        toast.error("Google sign-in didn't finish. Please try again.");
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      }
    };
    finish();
  }, [location, navigate, setUser]);

  return (
    <div className="garden-bg flex items-center justify-center min-h-screen">
      <Loader2 className="w-10 h-10 text-pink-400 animate-spin" />
    </div>
  );
}

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Garden />} />
        <Route path="/roses" element={<Roses />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/member/:id" element={<Member />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
          <Toaster position="top-center" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
